import { Button, Card, CardContent, Typography } from "@material-ui/core";
import React from "react";

// import { useDispatch } from "react-redux";
import useStyles from "../useStyles";

import RegisterDialog from "./RegisterDialog";
import RegisterTable from "./RegisterTable";

/**
 * RegisterCardコンポーネント.
 *
 * @return {object} コンポーネント
 */
function RegisterCard() {
  // スタイル
  const styles = useStyles();

  // Dispatch
  // const dispatch = useDispatch();

  // データ登録ダイアログの表示状態State（true: 表示、false: 非表示）
  const [isOpenRegisterDialog, setIsOpenRegisterDialog] = React.useState(false);
  const filePrefix = "00000/";

  return (
    <>
      <Card className={styles.card}>
        <CardContent className={styles.cardContent}>
          <Button
            className={styles.registerButton}
            size="large"
            variant="contained"
            color="primary"
            onClick={() => setIsOpenRegisterDialog(true)}
          >
            データ登録
          </Button>
        </CardContent>
        <CardContent className={styles.cardContent}>
          <Typography variant="body2" style={{ fontWeight: "bold" }}>
            【注意事項】
          </Typography>
          <Typography variant="body2">
            &emsp;1.&nbsp;IPCから回収、または「ファイル一覧」メニュー&nbsp;&gt;&nbsp;「00000&nbsp;:&nbsp;一時保存フォルダ」からダウンロードしたZIPファイルを指定します
          </Typography>
          <Typography variant="body2">
            &emsp;2.&nbsp;ZIPファイル名は「データ採取日付@工番@客先名称@プレス型式.zip」の命名規則に沿っているものとします
          </Typography>
        </CardContent>
        <CardContent className={styles.cardContent}>
          <RegisterTable />
        </CardContent>
      </Card>
      {/* データ登録ダイアログ */}
      <RegisterDialog
        isOpenDialog={isOpenRegisterDialog}
        onClose={() => setIsOpenRegisterDialog(false)}
        filePrefix={filePrefix}
      />
    </>
  );
}

export default RegisterCard;
